document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.js-venues-list').forEach(function (list) {
		const batch = parseInt(list.dataset.venuesBatch, 10) || 4;
		const items = Array.from(list.children);
		const pagination = list.parentElement.querySelector('.js-venues-pagination');

		if (pagination) {
			const pageItems = Array.from(pagination.querySelectorAll('.js-venues-page'));
			const prevItem = pagination.querySelector('.js-venues-prev');
			const nextItem = pagination.querySelector('.js-venues-next');
			const totalPages = Math.max(1, Math.ceil(items.length / batch));
			let currentPage = 1;

			const showPage = function (page) {
				currentPage = Math.min(Math.max(page, 1), totalPages);

				items.forEach(function (el, index) {
					el.classList.toggle('d-none', Math.floor(index / batch) + 1 !== currentPage);
				});

				pageItems.forEach(function (link) {
					link.parentElement.classList.toggle('active', parseInt(link.dataset.page, 10) === currentPage);
				});

				if (prevItem) {
					prevItem.parentElement.classList.toggle('disabled', currentPage === 1);
				}

				if (nextItem) {
					nextItem.parentElement.classList.toggle('disabled', currentPage === totalPages);
				}
			};

			const goToPage = function (page) {
				showPage(page);
				list.scrollIntoView({ behavior: 'smooth', block: 'start' });
			};

			pageItems.forEach(function (link) {
				link.addEventListener('click', function () {
					goToPage(parseInt(link.dataset.page, 10));
				});
			});

			if (prevItem) {
				prevItem.addEventListener('click', function () {
					goToPage(currentPage - 1);
				});
			}

			if (nextItem) {
				nextItem.addEventListener('click', function () {
					goToPage(currentPage + 1);
				});
			}

			showPage(1);

			return;
		}

		const btn = list.parentElement.querySelector('.js-venues-load-next');

		if (!btn) {
			return;
		}

		let shown = batch;

		btn.addEventListener('click', function () {
			items.slice(shown, shown + batch).forEach(function (el) {
				el.classList.remove('d-none');
			});
			shown += batch;

			if (shown >= items.length) {
				btn.classList.add('d-none');
			}
		});
	});
});
